import React, { useContext, useState } from "react";
import { EmpdContext } from "../../Context";
import { createUseStyles } from "react-jss";
import { globe } from "../../Assets/Images";
import ContentWrapper from "../ContentWrapper";
import { LEADERSHIP_PAGE_CONTENT } from "../../Consts/siteVerbiage";
import { Avatar, Divider, IconButton, Menu, MenuItem, Tooltip } from "@mui/material";

const useStyles = createUseStyles({
  root: {
    width: "100%",
    backgroundImage: `url(${globe})`,
    backgroundColor: "rgba(255,255,255,0.85)",
    backgroundBlendMode: "lighten",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "left",
    backgroundSize: "45%",
  },
  rootInner: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
  },
  welcomeMessage: {
    display: "flex",
    flexDirection: "column",
    padding: "25px 0px",
    "& h2": {
      margin: 0,
    },
    "& h4": {
      marginTop: 5,
      marginBottom: 0,
    },
  },
  patientData: {
    display: "flex",
    flexDirection: "column",
    padding: "20px 0px",
    textAlign: "right",
    "& h3": {
      margin: 0,
    },
    "& p": {
      marginTop: 5,
      marginBottom: 0,
    },
  },
  subLink: {
    textDecoration: "none",
    padding: "5px 0px",
    color: "#002F6C",
    fontSize: "14px",
  },
});

const useMyContext = () => {
    const context = useContext(EmpdContext)
    if( !context ) {
        throw new Error("No provider found for Context")
    }
    return context
}

const WelcomeBanner = () => {
  const classes = useStyles();
  const context = useMyContext();
  const { user } = context;
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event:any) => setAnchorEl(event.currentTarget);
  const handleClose = () => {
        setAnchorEl(null);
  }
  const handleCloseContact = () => {
    window.location.href = `/leadership/#${LEADERSHIP_PAGE_CONTENT.CONTACT.ID}`
        setAnchorEl(null);
  }
  const handleCloseLogout = () => {
        window.location.href = `/logout`
        setAnchorEl(null);
  }

  return (
    <div className={classes.root}>
      <ContentWrapper>
        <div className={classes.rootInner}>
          <div className={classes.welcomeMessage}>
            <h2>EMPD Provider Dashboard</h2>
            {user && user.first_name && (
            <h4>{`Welcome Back, ${user.first_name} ${user.last_name}!`}</h4>
            )}
          </div>
          <div className={classes.patientData}>
            {user && user.first_name && user.last_name && (
                <div>
                        <Tooltip title="Account settings">
                                <IconButton onClick={handleClick} size="large" aria-controls={open ? 'account-menu' : undefined}>
                                        <Avatar sx={{
                                                width: 48,
                                                height: 48,
                                                bgcolor: '#152E54',
                                                color: '#f6bb60'
                                        }}>
                                                {user.first_name.charAt(0) + user.last_name.charAt(0)}
                                        </Avatar>
                                </IconButton>
                        </Tooltip>
                        <Menu
                                anchorEl={anchorEl}
                                id="account-menu"
                                open={open}
                                onClose={handleClose}
                                onClick={handleClose}
                        >
                                <MenuItem sx={{ color: '#152E54' }} onClick={handleCloseContact}>Contact the Team</MenuItem>
                                <Divider />
                                <MenuItem sx={{ color: '#152E54' }} onClick={handleCloseLogout}>Logout</MenuItem>
                        </Menu>

                </div>
            )}
          </div>
        </div>
      </ContentWrapper>
    </div>
  );
};

export default WelcomeBanner;
